import { Outlet } from 'react-router-dom';
import { SkipLink } from '@/components/skip-link';
import { Header } from '@/components/layout/header';
import { Footer } from '@/components/layout/footer';

export function PublicOnlyLayout() {
  return (
    <div className="public-shell min-h-screen flex flex-col">
      <SkipLink />
      <Header mostrarAccesoPrivado={false} />
      <main id="main" className="public-main flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
